export const ERROR_PAGE_CODE = {
  NOT_FOUND: 404,
  ERROR: 500,
};

export type ErrorPageCodeName = keyof typeof ERROR_PAGE_CODE;

export type ErrorPageCodeValue = (typeof ERROR_PAGE_CODE)[ErrorPageCodeName];
